import { type CSSProperties } from "react"
import { Box, HardDrive } from "lucide-react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { rgbFor } from "@/shared/colors"
import type { DashboardServer } from "./api"

interface Props {
  servers: DashboardServer[]
}

export function ServersOverview({ servers }: Props) {
  const { t } = useTranslation("dashboard")
  return (
    <div className="box overflow-hidden p-4" style={{ "--c": rgbFor("/vms") } as CSSProperties}>
      <h3 className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500 mb-2">
        {t("sections.servers")}
      </h3>
      {servers.length === 0 ? (
        <p className="text-xs text-zinc-500 py-4 text-center">{t("sections.servers_empty")}</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1">
          {servers.map((s) => {
            const Icon = s.kind === "vm" ? HardDrive : Box
            const tone = s.actual_state === "running" ? "emerald" :
                         s.actual_state === "error" ? "rose" : "zinc"
            const dot: Record<string, string> = {
              emerald: "bg-emerald-400 shadow-[0_0_5px_rgba(52,211,153,0.55)]",
              rose: "bg-rose-400",
              zinc: "bg-zinc-600",
            }
            return (
              <Link key={`${s.kind}:${s.id}`}
                to={s.kind === "vm" ? `/vms/${s.id}` : `/containers/${s.id}`}
                className="flex items-center gap-2 px-2 py-1 rounded-md hover:bg-white/[4%] transition-colors min-w-0">
                <Icon size={11} className="text-violet-300 flex-shrink-0" />
                <span className="text-[11px] text-zinc-200 flex-1 truncate font-mono">{s.name}</span>
                <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dot[tone]}`} />
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
